import { Fragment } from 'react'
import { NextSeo } from 'next-seo'
import { useTranslation } from 'next-i18next'

import env from '@/lib/env'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'
import { AlternateLink } from '@/components/AlternateLink'

import Blogs from '@/features/landing/templates/Blogs'
import Contact from '@/features/landing/templates/Contact'
import ResourceList from '@/features/resources/templates/ResourceList'
import { ResourcePageProps } from '@/features/resources/types'
import {
  useEbooks,
  useTools,
  useDatasheets,
} from '@/features/resources/constants/resources'

import Hero from './Hero'

export const useMeta = (): PageMeta => {
  const { t } = useTranslation('handout')

  return {
    title: t('meta.title'),
    description: t('meta.description'),
    og: {
      title: t('meta.og.title'),
      description: t('meta.og.description'),
      image: {
        url: `${env.APP_URL}${t('meta.og.image.url')}`,
      },
    },
  }
}

function ResourceListPage({ blogs }: ResourcePageProps): React.ReactElement {
  const META = useMeta()

  const EBOOKS = useEbooks()
  const TOOLS = useTools()
  const DATASHEETS = useDatasheets()

  return (
    <Fragment>
      <AlternateLink />
      <NextSeo
        title={META.title}
        description={META.description}
        openGraph={{
          title: META.title,
          description: META.description,
          images: [
            {
              url: META.og.image.url,
              width: 1200,
              height: 630,
              alt: META.title,
            },
          ],
        }}
      />
      <NavigationBar />
      <Hero />
      <ResourceList ebooks={EBOOKS} tools={TOOLS} datasheets={DATASHEETS} />
      {blogs && <Blogs blogs={blogs} />}
      <Contact />
      <Footer />
    </Fragment>
  )
}

export default ResourceListPage
